function itemsUpdater(modifiedItem) {
    return (allItems) => {
        const itemsCopy = [...allItems];
        const index = itemsCopy.findIndex((pr) => pr.id === modifiedItem.id);
        itemsCopy[index] = modifiedItem;
        return itemsCopy;
    };
}
export default itemsUpdater;
